import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sports';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-2xl font-heading font-bold tracking-tight text-primary-400">
                bb<span className="text-background-100">体育</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              bb体育是您值得信赖的体育竞技娱乐平台，汇聚全球顶级体育赛事，提供专业赛事分析和数据服务，安全稳定，极速体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-200 mb-4 uppercase tracking-wider">
              赛事分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-200 mb-4 uppercase tracking-wider">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/football" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer">
                  赛事直播
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200 cursor-pointer">
                  联系我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-200 mb-4 uppercase tracking-wider">
              联系我们
            </h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-background-400 text-sm"></i>
                </div>
                <span className="text-sm text-background-400">service@bbsports.com</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-customer-service-2-line text-background-400 text-sm"></i>
                </div>
                <span className="text-sm text-background-400">7×24小时在线客服</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-background-400 text-sm"></i>
                </div>
                <span className="text-sm text-background-400">亚太运营中心</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 bb体育. All rights reserved. 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors duration-200" aria-label="Twitter">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-twitter-x-line text-sm"></i>
              </div>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors duration-200" aria-label="Telegram">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-telegram-line text-sm"></i>
              </div>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors duration-200" aria-label="Instagram">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-instagram-line text-sm"></i>
              </div>
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors duration-200" aria-label="WeChat">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}